import { render } from "./Surname.vue?vue&type=template&id=b108fe36&scoped=true"
import script from "./Surname.vue?vue&type=script&lang=js"
export * from "./Surname.vue?vue&type=script&lang=js"

import "./Surname.vue?vue&type=style&index=0&id=b108fe36&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b108fe36"]])

export default __exports__